import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "delete" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 12,
			cy: 12,
			r: 11.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 4.045,
			y1: 19.955,
			x2: 19.955,
			y2: 4.045
		})
	]
});
export default SvgDelete;
